exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DialogActions_actions__1oT1D{padding:.75rem 1rem;display:flex;justify-content:space-between;flex:0 0 auto;flex-wrap:wrap}.DialogActions_primaryActions__1i-Iz>*{margin-left:.5rem}.DialogActions_secondaryActions__1D1nP>*{margin-right:.5rem}", ""]);

// exports
exports.locals = {
	"actions": "DialogActions_actions__1oT1D",
	"primaryActions": "DialogActions_primaryActions__1i-Iz",
	"secondaryActions": "DialogActions_secondaryActions__1D1nP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/DialogLayout/Custom/DialogActions.less
// module id = 2071
// module chunks = 8